<template>
	<article>
		<section class="xbed-sub-title">
			<span>丽家会物品更换报表</span>
		</section>

		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>报表</BreadcrumbItem>
				<BreadcrumbItem>丽家会物品更换报表</BreadcrumbItem>
			</Breadcrumb>
		</section>

		<section style="margin-top:20px">
			<Form :model="replaceForm" inline>
				<Row>
					<FormItem label="查看日期：" prop="checkDate" :label-width="80">
						<DatePicker v-model="replaceForm.checkDate" @on-change="dateRange => {changeDate(dateRange, 'replaceForm', 'checkDate')}" :clearable="false" format="yyyy-MM-dd" type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
					</FormItem>
					<FormItem label="业主姓名：" prop="ownerName" :label-width="80">
						<Input type="text" v-model="replaceForm.ownerName"></Input>
					</FormItem>
					<FormItem label="房间ID：" prop="roomId" :label-width="80">
						<Input type="text" v-model="replaceForm.roomId"></Input>
					</FormItem>
					<FormItem label="房间名称：" prop="roomName" :label-width="80">
						<Input type="text" v-model="replaceForm.roomName"></Input>
					</FormItem>
				</Row>
				<Row>
					<FormItem label="省份：" prop="province" :label-width="80">
						<Select v-model="replaceForm.province" @on-change="changeSelect('province')" clearable filterable>
							<Option v-for="province in provinces" :key="province.id" :value="province.name">{{province.name}}</Option>
						</Select>
					</FormItem>
					<FormItem label="城市：" prop="city" :label-width="80">
						<Select v-model="replaceForm.city" @on-change="changeSelect('city')" clearable filterable>
							<Option v-for="city in cities" :key="city.id" :value="city.name">{{city.name}}</Option>
						</Select>
					</FormItem>
					<!-- <FormItem label="热点：" prop="hotspotId" :label-width="80">
            <Select v-model="replaceForm.hotspotId" @on-change="changeSelect('hotspotId')" clearable filterable>
              <Option v-for="hotspot in hotpots" :key="hotspot.id" :value="hotspot.id">{{hotspot.hotspotName}}</Option>
            </Select>
          </FormItem> -->
					<FormItem label="门店：" prop="chainName" :label-width="80">
						<Select v-model="replaceForm.chainName" clearable filterable>
							<Option v-for="chain in chains" :key="chain.chainId" :value="chain.chainId">{{chain.chainName}}</Option>
						</Select>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="queryListGoodsReportWithKeyword">查询</Button>
					</FormItem>
					<FormItem>
						<Button type="primary" @click="exportReportData" :loading="exportBtn[this.currTabName]">导出筛选结果</Button>
					</FormItem>
				</Row>
			</Form>
		</section>

		<Tabs class="tabs" @on-click="toggleTab">
			<TabPane label="房间易耗品补充报表" name="goodsList" ref="goodsList">
				<Table stripe :loading="goodsList.loading" ref="replaceTable" :columns="columns.goods" :data="goodsList.data"></Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="goodsList.count" :current="goodsList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
			<TabPane label="房间布草更换报表" name="linenList" ref="linenList">
				<Table stripe :loading="linenList.loading" ref="replaceTable" :columns="columns.linen" :data="linenList.data"></Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" :total="linenList.count" :current="linenList.page" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</TabPane>
		</Tabs>

	</article>
</template>

<script>
import Moment from 'moment';
import Config from "../../config";
import Utils from "../../utils";
import API from "../../api";
export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
	},
	async mounted() {
		this.$Notice.config( {
			top: 200
		} );
		this.queryProvinceList();
		this.queryHotspotList();
		this.queryChainList();
		this.listGoodsReport();
	},
	data() {
		let defaultDate = [
			Moment().subtract( 14, 'day' ).format( "YYYY-MM-DD" ),
			Moment().format( "YYYY-MM-DD" )
		];
		return {
			exportBtn: {
				goodsList: false,
				linenList: false
			},
			currTabName: "goodsList",
			columns: {
				goods: [
					{
						title: "房间ID",
						key: "roomId",
						align: "center",
						width: 100
					},
					{
						title: "房间名称",
						key: "roomName",
						align: "center",
						width: 150
					},
					{
						title: "省份",
						key: "province",
						width: 100,
						align: "center"
					},
					{
						title: "城市",
						key: "city",
						width: 100,
						align: "center"
					},
					// {
					//   title: "热点ID",
					//   key: "hotspotId",
					//   width: 100,
					//   align: "center"
					// },
					// {
					//   title: "热点名称",
					//   key: "hotspotName",
					//   width: 200,
					//   align: "center"
					// },
					{
						title: "门店ID",
						key: "chainId",
						width: 100,
						align: "center"
					},
					{
						title: "门店名称",
						key: "chainName",
						width: 150,
						align: "center"
					},
					{
						title: "业主ID",
						key: "ownerId",
						width: 100,
						align: "center"
					},
					{
						title: "业主姓名",
						key: "ownerName",
						width: 100,
						align: "center"
					},
					{
						title: "牙具",
						key: "toothToolNumber",
						width: 80,
						align: "center"
					},
					{
						title: "梳子",
						key: "combNumber",
						width: 80,
						align: "center"
					},
					{
						title: "洗发露",
						key: "shampooNumber",
						width: 80,
						align: "center"
					},
					{
						title: "沐浴露",
						key: "showergelNumber",
						width: 80,
						align: "center"
					},
					{
						title: "洗手液",
						key: "sanitizerNumber",
						width: 80,
						align: "center"
					},
					{
						title: "洗衣液",
						key: "laundryDetergentNumber",
						width: 80,
						align: "center"
					},
					{
						title: "护发素",
						key: "hairConditionerNumber",
						width: 80,
						align: "center"
					},
					{
						title: "卷纸",
						key: "rollPaperNumber",
						width: 80,
						align: "center"
					},
					{
						title: "拖鞋",
						key: "slipperNumber",
						width: 80,
						align: "center"
					},
					{
						title: "抽纸",
						key: "tissueNumber",
						width: 80,
						align: "center"
					},
					{
						title: "斯里兰卡红茶",
						key: "blackTeaNumber",
						width: 100,
						align: "center"
					},
					{
						title: "恒大冰泉500ml",
						key: "mineralWaterNumber",
						width: 100,
						align: "center"
					}
				],
				linen: [
					{
						title: "房间ID",
						key: "roomId",
						align: "center",
						width: 100
					},
					{
						title: "房间名称",
						key: "roomName",
						align: "center",
						width: 150
					},
					{
						title: "省份",
						key: "province",
						width: 100,
						align: "center"
					},
					{
						title: "城市",
						key: "city",
						width: 100,
						align: "center"
					},
					// {
					//   title: "热点ID",
					//   key: "hotspotId",
					//   width: 100,
					//   align: "center"
					// },
					// {
					//   title: "热点名称",
					//   key: "hotspotName",
					//   width: 200,
					//   align: "center"
					// },
					{
						title: "门店ID",
						key: "chainId",
						width: 100,
						align: "center"
					},
					{
						title: "门店名称",
						key: "chainName",
						width: 200,
						align: "center"
					},
					{
						title: "业主ID",
						key: "ownerId",
						width: 90,
						align: "center"
					},
					{
						title: "业主姓名",
						key: "ownerName",
						width: 100,
						align: "center"
					},
					{
						title: "地巾",
						key: "floorTowel",
						width: 80,
						align: "center"
					},
					{
						title: "面巾",
						key: "facialTowel",
						width: 80,
						align: "center"
					},
					{
						title: "浴巾",
						key: "bathTowel",
						width: 80,
						align: "center"
					},
					{
						title: "乳胶枕",
						key: "latexPillow",
						width: 100,
						align: "center"
					},
					{
						title: "普通枕芯",
						key: "normalPillowInner",
						width: 100,
						align: "center"
					},
					{
						title: "普通枕套",
						key: "normalPillowCover",
						width: 100,
						align: "center"
					},
					{
						title: "被芯",
						key: "duvet",
						width: 80,
						align: "center"
					},
					{
						title: "被套",
						key: "duvetCover",
						width: 80,
						align: "center"
					},
					{
						title: "床单",
						key: "bedSheet",
						width: 80,
						align: "center"
					},
					{
						title: "保护垫",
						key: "protectMat",
						width: 100,
						align: "center"
					},
					{
						title: "被芯1.2m",
						key: "duvetSingle",
						width: 90,
						align: "center"
					},
					{
						title: "被套1.2m",
						key: "duvetCoverSingle",
						width: 90,
						align: "center"
					},
					{
						title: "床单1.2m",
						key: "bedSheetSingle",
						width: 90,
						align: "center"
					},
					{
						title: "保护垫1.2m",
						key: "protectMatSingle",
						width: 90,
						align: "center"
					},
					{
						title: "被芯1.5m",
						key: "duvetDouble",
						width: 90,
						align: "center"
					},
					{
						title: "被套1.5m",
						key: "duvetCoverDouble",
						width: 90,
						align: "center"
					},
					{
						title: "床单1.5m",
						key: "bedSheetDouble",
						width: 90,
						align: "center"
					},
					{
						title: "保护垫1.5m",
						key: "protectMatDouble",
						width: 90,
						align: "center"
					},
					{
						title: "被芯1.8m",
						key: "duvetQueen",
						width: 90,
						align: "center"
					},
					{
						title: "被套1.8m",
						key: "duvetCoverQueen",
						width: 90,
						align: "center"
					},
					{
						title: "床单1.8m",
						key: "bedSheetQueen",
						width: 90,
						align: "center"
					},
					{
						title: "保护垫1.8m",
						key: "protectMatQueen",
						width: 90,
						align: "center"
					},
					{
						title: "被芯2.0m",
						key: "duvetKing",
						width: 90,
						align: "center"
					},
					{
						title: "被套2.0m",
						key: "duvetCoverKing",
						width: 90,
						align: "center"
					},
					{
						title: "床单2.0m",
						key: "bedSheetKing",
						width: 90,
						align: "center"
					},
					{
						title: "保护垫2.0m",
						key: "protectMatKing",
						width: 90,
						align: "center"
					}
				]
			},
			provinces: [],
			cities: [],
			hotpots: [],
			chains: [],
			replaceForm: {
				checkDate: defaultDate,
				ownerName: "",
				roomId: "",
				roomName: "",
				province: "",
				city: "",
				hotspotId: "",
				chainName: ""
			},
			goodsList: {
				tabName: "goodsList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
			linenList: {
				tabName: "linenList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			},
		};
	},
	methods: {
		toggleTab( tabName ) {
			this.currTabName = tabName;
			this[tabName].page = 1;
			this.queryReplaceReport();
		},
		changePage( pageIndex ) {
			this[this.currTabName].page = pageIndex;
			this.queryReplaceReport();
		},
		changePageSize( pageSize ) {
			this[this.currTabName].page = 1;
			this[this.currTabName].pageSize = pageSize;
			this.queryReplaceReport();
		},
		// TODO: 热点与门店联动，需要调整
		changeSelect( type ) {
			if ( type == "province" ) {
				this.replaceForm.city = "";
				this.replaceForm.hotspotId = "";
				if ( !this.replaceForm.province ) {
					this.cities = [];
				} else {
					this.queryCityList();
					this.queryHotspotList();
				}
			} else if ( type == "city" ) {
				this.replaceForm.hotspotId = "";
				this.queryHotspotList();
			}
			this.replaceForm.chainName = "";
			this.queryChainList();
		},
		async queryProvinceList() {
			let selectProvincesListResp = ( await API.omsAPI[this.env].order.queryProvinceList( this.token ) ).data
			if ( selectProvincesListResp instanceof Array ) {
				this.provinces = selectProvincesListResp;
			}
		},
		async queryCityList() {
			let selectCitiesListResp = ( await API.omsAPI[this.env].order.queryCityList( this.replaceForm.province, this.token ) ).data
			if ( selectCitiesListResp instanceof Array ) {
				this.cities = selectCitiesListResp;
			}
		},
		async queryHotspotList() {
			let params = {};
			this.replaceForm.province ? params.provinceName = this.replaceForm.province : '';
			this.replaceForm.city ? params.cityName = this.replaceForm.city : '';
			let selectHotspotsListResp = ( await API.omsAPI[this.env].order.queryHotspotList( params, this.token ) ).data
			if ( selectHotspotsListResp instanceof Array ) {
				this.hotpots = selectHotspotsListResp;
			}
		},
		async queryChainList() {
			let params = {};
			this.replaceForm.province ? params.provinceName = this.replaceForm.province : '';
			this.replaceForm.city ? params.cityName = this.replaceForm.city : '';
			this.replaceForm.hotspotId ? params.hotspotId = this.replaceForm.hotspotId : '';
			let selectChainsListResp = ( await API.omsAPI[this.env].order.queryChainList( params, this.token ) ).data
			if ( selectChainsListResp instanceof Array ) {
				this.chains = selectChainsListResp;
			}
		},
		queryListGoodsReportWithKeyword() {
			if ( !this.checkReportAccess() ) {
				return;
			}
			this[this.currTabName].page = 1;
			this.queryReplaceReport();
		},
		queryReplaceReport() {
			if ( this.currTabName == "goodsList" ) {
				this.listGoodsReport();
			} else if ( this.currTabName == "linenList" ) {
				this.listLinenReport();
			}
		},
		async listGoodsReport() {
			this.goodsList.loading = true;

			let resp = ( await this.sendListGoodsReport(
				this.goodsList,
				this.token,
				this.env
			) ).data;
			if ( resp.status === false ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: resp.msg
				} );
			}
			this.goodsList.data = resp.list;
			this.goodsList.count = resp.rowCount;
			this.goodsList.loading = false;
		},
		sendListGoodsReport( goodsList, token, env ) {
			let params = {
				page: goodsList.page,
				rows: goodsList.pageSize,
				queryStartDate: Moment( this.replaceForm.checkDate[0] ).format( "YYYY-MM-DD" ),
				queryEndDate: Moment( this.replaceForm.checkDate[1] ).format( "YYYY-MM-DD" )
			};

			this.replaceForm.ownerName
				? ( params.ownerName = this.replaceForm.ownerName )
				: "";
			this.replaceForm.roomId ? ( params.roomId = this.replaceForm.roomId ) : "";
			this.replaceForm.roomName
				? ( params.roomName = this.replaceForm.roomName )
				: "";
			this.replaceForm.province
				? ( params.province = this.replaceForm.province )
				: "";
			this.replaceForm.city
				? ( params.city = this.replaceForm.city )
				: "";
			this.replaceForm.hotspotId
				? ( params.hotspotId = this.replaceForm.hotspotId )
				: "";
			this.replaceForm.chainName
				? ( params.chainName = this.replaceForm.chainName )
				: "";
			return API.omsAPI[env].order.getBillRoomConsumables( params, token );
		},
		async listLinenReport() {
			this.linenList.loading = true;
			let resp = ( await this.sendListLinenReport(
				this.linenList,
				this.token,
				this.env
			) ).data;
			this.linenList.data = resp.list;
			this.linenList.count = resp.rowCount;
			this.linenList.loading = false;
		},
		sendListLinenReport( linenList, token, env ) {
			let params = {
				page: linenList.page,
				rows: linenList.pageSize,
				queryStartDate: Moment( this.replaceForm.checkDate[0] ).format( "YYYY-MM-DD" ),
				queryEndDate: Moment( this.replaceForm.checkDate[1] ).format( "YYYY-MM-DD" )
			};
			this.replaceForm.ownerName
				? ( params.ownerName = this.replaceForm.ownerName )
				: "";
			this.replaceForm.roomId ? ( params.roomId = this.replaceForm.roomId ) : "";
			this.replaceForm.roomName
				? ( params.roomName = this.replaceForm.roomName )
				: "";
			this.replaceForm.province
				? ( params.province = this.replaceForm.province )
				: "";
			this.replaceForm.city
				? ( params.city = this.replaceForm.city )
				: "";
			this.replaceForm.hotspotId
				? ( params.hotspotId = this.replaceForm.hotspotId )
				: "";
			this.replaceForm.chainName
				? ( params.chainName = this.replaceForm.chainName )
				: "";
			return API.omsAPI[env].order.getCleanLinenReport( params, token );
		},
		checkReportAccess() {
			if ( this.replaceForm.checkDate.join( '' ).length == 0 ) {
				this.$Notice.error( {
					title: "查询失败",
					desc: "查看日期不能为空"
				} );
				return false;
			}
			return true;
		},
		changeDate( dateRange, formName, datePicker ) {
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = []
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( 'YYYY-MM-DD' )
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
		},
		exportReportData() {
			let api = this.currTabName == "goodsList" ? "excel/roomConsumablesBillListExcel?rows=999999&page=1" : "excel/cleanLinenReportExcel?rows=999999&pageSize=1";
			let exportUrl = `${ Config[this.env].analysisUrl }${ api }` +
				`&queryStartDate=${ Moment( this.replaceForm.checkDate[0] ).format( "YYYY-MM-DD" ) }` +
				`&queryEndDate=${ Moment( this.replaceForm.checkDate[1] ).format( "YYYY-MM-DD" ) }` +
				`&ownerName=${ this.replaceForm.ownerName }` +
				`&roomId=${ this.replaceForm.roomId }` +
				`&roomName=${ this.replaceForm.roomName }` +
				`&province=${ this.replaceForm.province }` +
				`&city=${ this.replaceForm.city }` +
				`&hotspotId=${ this.replaceForm.hotspotId }` +
				`&chainName=${ this.replaceForm.chainName }`

			// window.open(exportUrl ,"_blank");
			Utils.exportExcelWeighting( exportUrl, this.token, this.$Notice.error, this.exportBtn, this.currTabName )
		},
		resetTabPane() {
			this.goodsList = {
				tabName: "goodsList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
			this.linenList = {
				tabName: "linenList",
				count: 0, //记录总数
				pageCount: 0, //页面总数
				page: 1, // 第几页
				pageSize: 10, // 每页数量
				loading: false,
				data: []
			};
		},
		refreshTable() {
			this.resetTabPane();
			this.queryReplaceReport();
		}
	}
};
</script>

<style lang="scss" scoped>
.add-wrapper {
	margin-top: 20px;
}

.table-wrapper {
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/report/replace-report.vue